export default "__VITE_ASSET__b2236fb1__"